import { PageContentLayout } from '@tassomutuo-backoffice/ui';
import { useQuery } from '@tanstack/react-query';
import { getAllTeams } from '../../../services/api/team/team';
import { selectUser, useUserStore } from '../../../store/user';
import TeamManagersTable from './components/TeamManagersTable';
import { useState } from 'react';
import { Team } from '@tassomutuo-backoffice/types';
import TeamConfirmNotifyModal from './components/TeamConfirmNotifyModal';

const TeamsManagerPage = () => {
  const user = useUserStore(selectUser);
  const [teamToNotify, setTeamToNotify] = useState<Team | null>(null);

  const { isPending: isPendingTeams, data: teamsData } = useQuery({
    queryKey: ['Teams'],
    queryFn: getAllTeams,
    enabled: user?.role === 'admin',
  });

  const onNotifyTeamClick = (team: Team) => {
    setTeamToNotify(team);
  };

  return (
    <div>
      <PageContentLayout
        title="Teams Managers"
        error={null}
        isLoading={isPendingTeams}
      >
        <TeamManagersTable
          teams={teamsData || []}
          onNotifyTeamClick={onNotifyTeamClick}
          canSendEmailNotification={user?.role === 'admin'}
        />
      </PageContentLayout>
      {teamToNotify && (
        <TeamConfirmNotifyModal
          open
          handleClose={() => setTeamToNotify(null)}
          teamToNotify={teamToNotify}
        />
      )}
    </div>
  );
};

export default TeamsManagerPage;
